exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.table-head > tr > th[data-v-981766a0] {\n  background-color: transparent;\n}\n.table-body > tr > td[data-v-981766a0] {\n  border-top: 0;\n}\n", ""]);

// exports
